"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePage = exports.fetchPagesIfNeeded = exports.UPDATE_PAGE = exports.ADD_PAGE = exports.FETCH_PAGES = void 0;
var utils_1 = require("../../utils");
exports.FETCH_PAGES = (0, utils_1.networkActionTypes)("FETCH_PAGES");
exports.ADD_PAGE = (0, utils_1.networkActionTypes)("ADD_PAGE");
exports.UPDATE_PAGE = (0, utils_1.networkActionTypes)("UPDATE_PAGE");
var fetchPages = (0, utils_1.networkAction)(exports.FETCH_PAGES, "/pages");
exports.fetchPagesIfNeeded = (0, utils_1.makeIfNeededAction)(fetchPages, "pages");
var updatePage = function (pageID, pageData, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (state.pages.isFetching || state.pages.isAdding || state.pages.isUpdating)
            return;
        return dispatch((0, utils_1.networkAction)(exports.UPDATE_PAGE, "/pages/".concat(pageID), "PUT")(pageData, {}, accessToken));
    };
};
exports.updatePage = updatePage;
